import React, { useCallback, useEffect, useState } from "react";
import { useQuery, useTranslate } from "../../../../../../Hooks";
import { Box, CircularProgress } from "@material-ui/core";
import { useSelector } from "react-redux";
import {
  GetAllDFMTransactionForProperty,
  GetAllFormFieldsByFormId,
} from "../../../../../../Services";
import { NoDataFound } from "../../../../NoDataFound";
import CustomPaginationHistorySideMenu from "../UI/CustomPaginationHistorySideMenu/CustomPaginationHistorySideMenu";
import { FormsIdsEnum } from "../../../../../../Enums";
import PropertyHistoryTimeLine from "../UI/PropertyHistoryTimeLine/PropertyHistoryTimeLine";

// styles
import useStyles from "./styles";

const CustomPropertyHistoryComponent = ({ typeId, formType }) => {
  const styles = useStyles();
  const query = useQuery();
  const { translate } = useTranslate("NewPropertiesView");
  const activeItem = useSelector((state) => state.ActiveItemReducer);
  const [isLoading, setIsLoading] = useState(false);
  const pathName = window.location.pathname
    .split("/home/")[1]
    .split("/view")[0]
    .split("/")[0];
  const [pagination, setPagination] = useState({
    pageSize: 10,
    pageIndex: 0,
  });
  const [formsContent, setFormsContent] = useState([]);
  const [transactions, setTransactions] = useState({
    result: [],
    totalCount: 0,
  });

  const getAllDFMTransaction = useCallback(async () => {
    setIsLoading(true);
    let result;
    if (pathName.includes("Properties") || pathName.includes("properties"))
      result = await GetAllDFMTransactionForProperty(
        pagination.pageIndex,
        pagination.pageSize,
        query.get("id")
      );
    if (!(result && result.status && result.status !== 200)) {
      setTransactions({
        result: result && result.result,
        totalCount: result && result.totalCount,
      });
    } else setTransactions({ result: [], totalCount: 0 });
    setIsLoading(false);
  }, [pagination, pathName]);

  const GetAllFormByFormId = useCallback(async () => {
    let formId = 0;

    if (pathName.includes("Properties") || pathName.includes("properties"))
      formId = FormsIdsEnum.properties.id;
    else formId = 3;

    const result = await GetAllFormFieldsByFormId(formId);
    setFormsContent(
      result.map((item) => ({
        type: item.uiWidgetType,
        el: item.formFieldKey
          .replace("-", "_")
          .replace("-", "_")
          .replace("-", "_"),
      }))
    );
  }, [activeItem, pathName]);

  useEffect(() => {
    getAllDFMTransaction();
    GetAllFormByFormId();
  }, [getAllDFMTransaction, GetAllFormByFormId]);

  return (
    <Box className={styles.containerHistoryTimeLinePlsPaggination}>
      <Box className={styles.containerContactHistoryTimeLine}>
        {isLoading ? (
          <Box className={styles.loaderContainer}>
            <CircularProgress />
          </Box>
        ) : transactions?.result?.length > 0 ? (
          <PropertyHistoryTimeLine
            timelineItems={transactions.result}
            formsContent={formsContent}
            typeId={typeId}
            formType={formType}
            pathName={pathName}
          />
        ) : (
          <NoDataFound title={translate("history ")} />
        )}
      </Box>
      <CustomPaginationHistorySideMenu
        totalItems={transactions.totalCount}
        itemsPerPage={pagination?.pageSize}
        currentPage={pagination?.pageIndex}
        onPageChange={(page) =>
          setPagination((prev) => ({ ...prev, pageIndex: page }))
        }
        onItemsPerPageChange={(items) =>
          setPagination((prev) => ({ ...prev, pageSize: items }))
        }
      />
    </Box>
  );
};

export default CustomPropertyHistoryComponent;